import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedOnlyTagsOfNodeName extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'only_tags_of_node_name'
  alias: "Only tags of node name"
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeOnlyTagsOfNodeName(value)
